import { dateFormatter, DateFormatTypes } from '@jfs/utils'

export const CampaignGraphParser = (response: any) => {
  const values: string[] = Object.values(response?.data?.dailyDistribution ?? {})
  const keys: string[] = Object.keys(response?.data?.dailyDistribution ?? {})
  const retData = values.map((item, index) => {
    const getDate = () => {
      const date = new Date(keys[index])
      const isTodaysDate = new Date().getDate() === date?.getDate()
      const isTodaysMonth = new Date().getMonth() === date?.getMonth()
      const isTodaysYear = new Date().getFullYear() === date?.getFullYear()
      if (isTodaysDate && isTodaysMonth && isTodaysYear) {
        return 'Today'
      } else {
        return dateFormatter(date, DateFormatTypes.DAY_ONLY)
      }
    }

    return {
      id: `${index}`,
      date: getDate(),
      value: parseInt(item, 10),
      timestamp: new Date(keys[index])?.getTime(),
    }
  })
  retData?.sort((a: any, b: any) => (a.timestamp < b.timestamp ? -1 : a.timestamp > b.timestamp ? 1 : 0))
  return retData
}
